<template lang='pug'>
  .discover-events(:class='{ "no-top-padding": isMobileApp }')
    banner(page='events_index_page')
    Events(:events='filteredEvents')
    .empty-view(v-if='events.length===0' v-text='$t("bookingService.empty")')
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "There are currently no store events. Please check back soon."
    }
  },
  "lng_id": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "There are currently no store events. Please check back soon."
    }
  },
  "lng_zh": {
    "bookingService": {
      "metaDescription": "Discover more in Sephora stores, from the latest in-store promotions to exciting new launches and meet and greet sessions with your favourite brand owners.",
      "empty": "目前沒有門店活動。請密切留意。"
    }
  },
  "lng_th": {
    "bookingService": {
      "metaDescription": "ค้นพบความตื่นเต้นเร้าใจที่ร้านเซโฟราไปกับกิจกรรมเปิดตัวแบรนด์ใหม่พร้อมพบกับผู้ก่อตั้งแบรนด์ชื่อดังมากมายที่คุณชื่นชอบ.",
      "empty": "ยังไม่มีกิจกรรมที่สาขาในตอนนี้ โปรดกลับมาดูอีกครั้งในเร็ว ๆ นี้"
    }
  },
  "lng_ko": {
    "bookingService": {
      "metaDescription": "현재 진행중인 매장 프로모션부터 신제품 출시 소식, 기다리던 브랜드의 이벤트까지, 세포라의 오프라인 스토어에서 더 많은 경험을 즐겨보세요. ",
      "empty": "현재 진행 중인 매장 이벤트가 없습니다. 나중에 다시 확인해주세요. "
    }
  }
}
</i18n>

<script>
import { mapGetters, createNamespacedHelpers } from 'vuex'
import Banner from './reusable/banner.vue'
import Events from './reusable/events.vue'
import { fullUrl } from '@/modules/services/utilities'
import { setCookie } from '@/modules/services/cookies'

const { mapActions, mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'DiscoverEvents',
  components: { Banner, Events },
  computed: {
    ...mapGetters(['isMobileApp']),
    ...mapState(['events']),
      filteredEvents () {
      return this.events.filter(event => event.attributes['status'] === 'published')
    }
  },
  created () {
    this.storeQueryParamsInCookies()
  },
  mounted () {
    this.fetchEvents()
    this.$store.commit('setSeoMetaTitle', this.$t('retailStore.events'))
    this.$store.commit('setSeoMetaDescription', this.$t('bookingService.metaDescription'))
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },
  methods: {
    ...mapActions(['fetchEvents']),
    storeQueryParamsInCookies () {
      const params = this.$route.query
      const paramsToStore = ['firstAvailable']

      paramsToStore.forEach(param => {
        if (params[param]) {
          const expiryTime = new Date(Date.now() + 5 * 60 * 1000)
          setCookie(param, params[param], expiryTime, '/')
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .discover-events {
    @include media-breakpoint-down(md) {
      padding-right: 5px;
      padding-left: 5px;
    }

    @include media-breakpoint-down(sm) {
      padding: 10px;
    }

    &.no-top-padding {
      padding-top: 0;
    }

    .empty-view {
      padding-top: 16px;
      line-height: 18px;
    }
  }
</style>
